<template>
  <div class="detail-split-box box-border flex-container flex-column">
    <div class="content-title flex-container flex-row flex-horiz-apart">
      <span class="title">{{ title }}</span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.detail-split-box{
  background: #ffffff;
}
.content-title{
  font-size: 1.1429rem;
  color: @theme-grey-1;
  padding: 0.83rem 0;
  border-bottom: 1px solid @theme-border-color;
  .title{
    padding-left: 1.7143rem ;
    height: 1.5714rem;
  }
}
</style>
